// @ts-nocheck
import React from "react";
import { useLanguageContext } from "../context/languageContext";

export const CategoriesPreviewCard = ({ category, index }) => {
    const { t } = useLanguageContext();

    return (
        <div className="group relative flex flex-col gap-3">
            {/* App-Style Card with Glass Overlay */}
            <div className="relative aspect-square overflow-hidden rounded-[2rem] bg-slate-100 shadow-sm transition-transform duration-300 group-active:scale-95">
                <img
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    src={category.imageUrl}
                    alt={category.categoryName}
                    loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950/60 to-transparent opacity-60"></div>

                {/* Product Count / Label Badge */}
                {/* <div className="absolute top-3 right-3 px-2 py-1 rounded-full bg-white/20 backdrop-blur-md border border-white/20">
                    <span className="text-[9px] font-bold text-white uppercase tracking-tighter">Premium</span>
                </div> */}
            </div>

            {/* Clear, Legible App Label */}
            <div className="px-1 text-center">
                <h3 className="text-[18px] font-bold text-slate-900 leading-tight">
                    {t(`categories.${category.categoryName}`)}
                </h3>
            </div>
        </div>
    );
};
